import { EMPLOYEE } from "../actions/types";

const initialState = {
  createEmployee: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
  getEmployees: {
    employees: {},
    isFetching: false,
    errorMessage: null,
  },
  getEmployee: {
    employee: {},
    isFetching: false,
    errorMessage: null,
  },
  updateEmployee: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
  deleteEmployee: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
  checkEmployeeExists: {
    exists: null,
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
  getCompaniesOfEmployee: {
    companies: {},
    isFetching: false,
    errorMessage: null,
  },
  getSchedule: {
    schedule: [],
    isFetching: false,
    errorMessage: null,
  },
  activateEmployee: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
  deactivateEmployee: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    // #region EMPLOYEE.CREATE

    case EMPLOYEE.EMPLOYEE_CREATE_REQUEST:
      return {
        ...state,
        createEmployee: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case EMPLOYEE.EMPLOYEE_CREATE_SUCCESS:
      return {
        ...state,
        createEmployee: {
          successMessage: "Medewerker toevoegen is voltooid",
          errorMessage: null,
          isFetching: false,
        },
      };

    case EMPLOYEE.EMPLOYEE_CREATE_FAIL:
      return {
        ...state,
        createEmployee: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region EMPLOYEE.GET_EMPLOYEES

    case EMPLOYEE.EMPLOYEE_GET_EMPLOYEES_REQUEST:
      return {
        ...state,
        getEmployees: {
          employees: {},
          isFetching: true,
          errorMessage: null,
        },
      };

    case EMPLOYEE.EMPLOYEE_GET_EMPLOYEES_SUCCESS:
      return {
        ...state,
        getEmployees: {
          employees: action.payload,
          isFetching: false,
          errorMessage: null,
        },
      };

    case EMPLOYEE.EMPLOYEE_GET_EMPLOYEES_FAIL:
      return {
        ...state,
        getEmployees: {
          employees: {},
          isFetching: false,
          errorMessage: action.payload,
        },
      };

    // #endregion

    // #region EMPLOYEE.GET

    case EMPLOYEE.EMPLOYEE_GET_REQUEST:
      return {
        ...state,
        getEmployee: {
          employee: {},
          isFetching: true,
          errorMessage: null,
        },
      };

    case EMPLOYEE.EMPLOYEE_GET_SUCCESS:
      return {
        ...state,
        getEmployee: {
          employee: action.payload,
          isFetching: false,
          errorMessage: null,
        },
      };

    case EMPLOYEE.EMPLOYEE_GET_FAIL:
      return {
        ...state,
        getEmployee: {
          employee: {},
          isFetching: false,
          errorMessage: action.payload,
        },
      };

    // #endregion

    // #region EMPLOYEE_UPDATE

    case EMPLOYEE.EMPLOYEE_UPDATE_REQUEST:
      return {
        ...state,
        updateEmployee: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case EMPLOYEE.EMPLOYEE_UPDATE_SUCCESS:
      return {
        ...state,
        updateEmployee: {
          successMessage: "Bijwerken is voltooid",
          errorMessage: null,
          isFetching: false,
        },
      };

    case EMPLOYEE.EMPLOYEE_UPDATE_FAIL:
      return {
        ...state,
        updateEmployee: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region EMPLOYEE_DELETE

    case EMPLOYEE.EMPLOYEE_DELETE_REQUEST:
      return {
        ...state,
        deleteEmployee: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case EMPLOYEE.EMPLOYEE_DELETE_SUCCESS:
      return {
        ...state,
        deleteEmployee: {
          successMessage: "Medewerker verwijderen is voltooid",
          errorMessage: null,
          isFetching: false,
        },
      };

    case EMPLOYEE.EMPLOYEE_DELETE_FAIL:
      return {
        ...state,
        deleteEmployee: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region EMPLOYEE_CHECK_EXISTENCE

    case EMPLOYEE.EMPLOYEE_CHECK_EXISTENCE_REQUEST:
      return {
        ...state,
        checkEmployeeExists: {
          exists: null,
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case EMPLOYEE.EMPLOYEE_CHECK_EXISTENCE_SUCCESS:
      return {
        ...state,
        checkEmployeeExists: {
          exists: action.payload.exists,
          successMessage: null,
          errorMessage: null,
          isFetching: false,
        },
      };

    case EMPLOYEE.EMPLOYEE_CHECK_EXISTENCE_FAIL:
      return {
        ...state,
        checkEmployeeExists: {
          exists: null,
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region EMPLOYEE.GET_COMPANIES

    case EMPLOYEE.EMPLOYEE_GET_COMPANIES_REQUEST:
      return {
        ...state,
        getCompaniesOfEmployee: {
          companies: {},
          isFetching: true,
          errorMessage: null,
        },
      };

    case EMPLOYEE.EMPLOYEE_GET_COMPANIES_SUCCESS:
      return {
        ...state,
        getCompaniesOfEmployee: {
          companies: action.payload,
          isFetching: false,
          errorMessage: null,
        },
      };

    case EMPLOYEE.EMPLOYEE_GET_COMPANIES_FAIL:
      return {
        ...state,
        getCompaniesOfEmployee: {
          companies: {},
          isFetching: false,
          errorMessage: action.payload,
        },
      };

    // #endregion

    // #region EMPLOYEE.GET_SCHEDULE

    case EMPLOYEE.EMPLOYEE_GET_SCHEDULE_REQUEST:
      return {
        ...state,
        getSchedule: {
          schedule: [],
          isFetching: true,
          errorMessage: null,
        },
      };

    case EMPLOYEE.EMPLOYEE_GET_SCHEDULE_SUCCESS:
      return {
        ...state,
        getSchedule: {
          schedule: action.payload,
          isFetching: false,
          errorMessage: null,
        },
      };

    case EMPLOYEE.EMPLOYEE_GET_SCHEDULE_FAIL:
      return {
        ...state,
        getSchedule: {
          schedule: [],
          isFetching: false,
          errorMessage: [
            "Er is iets foutgegaan bij het ophalen van de agenda. Probeer het later opnieuw.",
          ],
        },
      };

    // #endregion

    // #region EMPLOYEE_ACTIVATE

    case EMPLOYEE.EMPLOYEE_ACTIVATE_REQUEST:
      return {
        ...state,
        activateEmployee: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case EMPLOYEE.EMPLOYEE_ACTIVATE_SUCCESS:
      return {
        ...state,
        activateEmployee: {
          successMessage: "Medewerker activeren is voltooid",
          errorMessage: null,
          isFetching: false,
        },
      };

    case EMPLOYEE.EMPLOYEE_ACTIVATE_FAIL:
      return {
        ...state,
        activateEmployee: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region EMPLOYEE_DEACTIVATE

    case EMPLOYEE.EMPLOYEE_DEACTIVATE_REQUEST:
      return {
        ...state,
        deactivateEmployee: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case EMPLOYEE.EMPLOYEE_DEACTIVATE_SUCCESS:
      return {
        ...state,
        deactivateEmployee: {
          successMessage: "Medewerker deactiveren is voltooid",
          errorMessage: null,
          isFetching: false,
        },
      };

    case EMPLOYEE.EMPLOYEE_DEACTIVATE_FAIL:
      return {
        ...state,
        deactivateEmployee: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/employeeReducer.js